import { httpClient } from '../lib/http-client';
import { Assunto } from '../types';

/**
 * Service para gerenciamento de assuntos
 */
export class AssuntosService {
  static async getAssuntos(): Promise<Assunto[]> {
    return httpClient.get<Assunto[]>('/api/assuntos');
  }

  static async getAssunto(id: number): Promise<Assunto> {
    return httpClient.get<Assunto>(`/api/assuntos/${id}`);
  }

  static async createAssunto(data: Partial<Assunto>): Promise<Assunto> {
    return httpClient.post<Assunto>('/api/assuntos', data);
  }

  static async updateAssunto(id: number, data: Partial<Assunto>): Promise<Assunto> {
    return httpClient.put<Assunto>(`/api/assuntos/${id}`, data);
  }

  static async deleteAssunto(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/assuntos/${id}`);
  }

  static async getAssuntosPorDepartamento(departamentoId: number): Promise<Assunto[]> {
    return httpClient.get<Assunto[]>(`/api/departamentos/${departamentoId}/assuntos`);
  }

  static async getAssuntosParaNovoTicket(departamentoId: number): Promise<Assunto[]> {
    return httpClient.get<Assunto[]>(`/api/departamentos/${departamentoId}/assuntos-ticket`);
  }
}

